import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../lib/api'
import type {
  UserSkill,
  UserSkillCreateInput,
  UserSkillUpdateInput,
} from '../types/capability'

interface UserSkillListResponse {
  items: UserSkill[]
}

export function useMySkills() {
  return useQuery<UserSkill[]>({
    queryKey: ['user-skills'],
    queryFn: async () => {
      const res = await api.get<UserSkillListResponse>('/user-skills')
      return res.data.items
    },
  })
}

export function useAddSkill() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: UserSkillCreateInput) => {
      const res = await api.post('/user-skills', input)
      return res.data as UserSkill
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['user-skills'] }),
  })
}

export function useUpdateSkill() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, body }: { id: number; body: UserSkillUpdateInput }) => {
      const res = await api.patch(`/user-skills/${id}`, body)
      return res.data as UserSkill
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['user-skills'] }),
  })
}

export function useRemoveSkill() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => {
      await api.delete(`/user-skills/${id}`)
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['user-skills'] }),
  })
}
